import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { loadEmployeeRolesAddDataRequest } from "../redux/Actions";
import EmployeeRoleMappingForm from "./EmployeeRoleMappingForm";

const EmployeeRoleMappingAdd = ({ handleClose }) => {
  const dispatch = useDispatch();
  let [submitted, setSubmitted] = useState(false);
  let [isClosing, setIsClosing] = useState(false);

  let { loading, error } = useSelector((state) => state.modules);

  // After submition, the post request is done loading, and there's no errors
  useEffect(() => {
    if (submitted && !loading && !isClosing) {
      setIsClosing(true);
      handleClose(true)
    }
  }, [loading, dispatch, error, handleClose, isClosing, submitted])

  function submit(values) {
    let request = {
      employee_id: values.employee_id,
      mapping: 
        values.role_module_id.map((values)=>{
          return {
            role_id: Number(values.split(',')[0]),
            group_id: Number(values.split(',')[1])
          }
        })
    }
    dispatch(loadEmployeeRolesAddDataRequest(request));
    setSubmitted(true);
  }
  function cancel() {
    handleClose(false);
  }
  return <EmployeeRoleMappingForm submit={submit} cancel={cancel} />;
};

export default EmployeeRoleMappingAdd;
